import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Divider from '@mui/material/Divider';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { useNavigate } from 'react-router-dom';

const mainListItems = [
  { text: 'Início', icon: <HomeRoundedIcon />, nav: 'dashboard' },
  // { text: 'Analytics', icon: <AnalyticsRoundedIcon /> },
  { text: 'Perfil', icon: <PersonRoundedIcon />, nav: 'profile' },
  { text: 'Meu plano', icon: <PaidRoundedIcon />, nav: 'payment' },
  {
    text: 'Tutoriais', icon: <PlayArrowRoundedIcon />,
    nav: 'tutorials',
  },
  {
    text: 'Modelos de Fluxo', icon: <AccountTreeIcon />,
    nav: 'flow-models',
  },
];

const secondaryListItems = [
  // { text: 'Settings', icon: <SettingsRoundedIcon /> },
  // { text: 'About', icon: <InfoRoundedIcon /> },
  // { text: 'Feedback', icon: <HelpRoundedIcon /> },
  { text: 'Termos e Políticas', icon: <AssignmentRoundedIcon />, nav: 'terms' },
];

export default function MenuContent() {
  const navigate = useNavigate();
  const currentPath = window.location.pathname.split('/')[1];  

  return (
    <Stack sx={{ flexGrow: 1, p: 1, }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton selected={item.nav === currentPath} onClick={() => navigate(`/${item.nav}`)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ marginBottom: '2px' }} />
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton onClick={() => window.open(`/${item.nav}`, '_blank')}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}